import { Component, h } from '@monygroupcorp/microact';

export class SwapInputs extends Component {
    constructor(props = {}) {
        super(props);
    }

    /**
     * Handle input change events
     * @param {Event} e - Input event
     * @param {string} inputType - 'top' or 'bottom'
     */
    handleInput(e, inputType) {
        const value = e.target.value;
        if (this.props.onInput) {
            this.props.onInput(inputType, value);
        }
    }

    render() {
        const { direction, ethAmount, execAmount, calculatingAmount, freeMint, balances = { eth: '0', exec: '0' } } = this.props;

        const formattedEthBalance = parseFloat(balances.eth || 0).toFixed(6);
        const formattedExecBalance = parseInt(balances.exec || 0).toLocaleString();

        const availableExecBalance = direction === 'sell' && freeMint
            ? `Available: ${(parseInt(balances.exec || 0) - 1000000).toLocaleString()}`
            : `Balance: ${formattedExecBalance}`;

        const topValue = direction === 'buy' ? ethAmount : execAmount;
        const bottomValue = direction === 'buy'
            ? (calculatingAmount ? 'Loading...' : execAmount)
            : (calculatingAmount ? 'Loading...' : ethAmount);

        const topSymbol = direction === 'buy' ? 'ETH' : '$EXEC';
        const bottomSymbol = direction === 'buy' ? '$EXEC' : 'ETH';

        const topBalance = direction === 'buy' ? `Balance: ${formattedEthBalance}` : availableExecBalance;
        const bottomBalance = direction === 'buy' ? `Balance: ${formattedExecBalance}` : `Balance: ${formattedEthBalance}`;

        return h('div', { className: 'swap-inputs' },
            h('div', { className: 'input-container' },
                h('input', {
                    type: 'text',
                    className: 'top-input',
                    value: topValue,
                    placeholder: '0.0',
                    pattern: '^[0-9]*[.]?[0-9]*$',
                    onInput: (e) => this.handleInput(e, 'top')
                }),
                h('div', { className: 'token-info' },
                    h('span', { className: 'token-symbol' }, topSymbol),
                    h('span', { className: 'token-balance' }, topBalance)
                )
            ),
            h('div', { className: 'direction-switch-slot' }),
            h('div', { className: 'input-container' },
                h('input', {
                    type: 'text',
                    className: 'bottom-input',
                    value: bottomValue,
                    placeholder: '0.0',
                    pattern: '^[0-9]*[.]?[0-9]*$',
                    onInput: (e) => this.handleInput(e, 'bottom')
                }),
                h('div', { className: 'token-info' },
                    h('span', { className: 'token-symbol' }, bottomSymbol),
                    h('span', { className: 'token-balance' }, bottomBalance)
                )
            )
        );
    }
}

export default SwapInputs;
